
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Jobs List
 */
const JobsList = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		JOBS_LIST: '.jobs-list'
	};

	/**
	 * Jobs List
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class JobsList extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.$element.tablesorter();
			this.$jobSelect = this.$element.parent().find('.jobs-select-wrap').find('.jobs-select-job');
			this.$locationSelect = this.$element.parent().find('.jobs-select-wrap').find('.jobs-select-location');
			this.selectedJob = this.$jobSelect.val() || null;
			this.selectedLocation = this.$locationSelect.val() || null;

			const filterLocations = () => {
				const $locations = this.$element.parent().find('.jobs-clubs-list [data-jobs]');
				$locations.each((i, location) => {
					if ($(location).data('jobs').includes(parseInt(this.selectedJob))) {
						$(location).addClass('visible');
					} else {
						$(location).removeClass('visible');
					}
				});
			};

			const filterJobs = () => {
				this.$element.find('.jobs-list-item').removeClass('visible');
				this.$element.parent().find('.jobs-list-empty').removeClass('visible');

				if (this.selectedLocation !== null) {
					if (this.selectedJob !== null) {
						// Job and location selected
						this.$element.find(`.jobs-list-item[data-location="${this.selectedLocation}"][data-job="${this.selectedJob}"]`).addClass('visible');
					} else {
						// Only location selected
						this.$element.find(`.jobs-list-item[data-location="${this.selectedLocation}"]`).addClass('visible');
					}

					if (!this.$element.find('.jobs-list-item.visible').length) {
						this.$element.css('display', 'none');
						this.$element.parent().find('.jobs-list-empty').addClass('visible');
					} else {
						this.$element.css('display', '');
					}
				} else if (this.selectedJob !== null) {
					this.$element.find(`.jobs-list-item[data-job="${this.selectedJob}"]`).addClass('visible');

					if (!this.$element.find('.jobs-list-item.visible').length) {
						this.$element.css('display', 'none');
						this.$element.parent().find('.jobs-list-empty').addClass('visible');
					} else {
						this.$element.css('display', '');
					}
				} else {
					this.$element.find(`.jobs-list-item`).addClass('visible');
				}
			};

			filterJobs();
			//filterLocations();

			this.$jobSelect.on('change', (event) => {
				const value = event.currentTarget.value;
				this.selectedJob = value ? value : null;
				//filterLocations();
				filterJobs();
			});

			this.$locationSelect.on('change', (event) => {
				const value = event.currentTarget.value;
				this.selectedLocation = value ? value : null;
				filterJobs();
			});
		}
	}

	return JobsList._getElements(Selector.JOBS_LIST, JobsList);
})();

export default JobsList;
